import { memo } from 'react'
import { ChevronUpIcon } from '@heroicons/react/24/outline'
import LiveStatusChip from './LiveStatusChip'

/**
 * EntitySemiMode - Compact thumbnail row shown when panel is in "semi" state.
 * Clicking/tapping expands to full panel.
 * @atomic @idempotent
 */
const EntitySemiMode = memo(function EntitySemiMode({
  entityDetails,
  imageUrl,
  IconComponent,
  bgColor,
  iconColor,
  isLive,
  localLiveUntil,
  handleImageError,
  onExpand,
  t,
}) {
  return (
    <div
      className="flex items-start gap-3 p-3 bg-white/85 backdrop-blur-sm rounded-lg shadow-sm border border-white/30 relative cursor-pointer hover:shadow-md transition-shadow"
      onClick={() => onExpand('expanded')}
      onTouchEnd={(e) => { e.preventDefault(); onExpand('expanded') }}
      role="button"
      tabIndex={0}
      aria-label={t('common.expandDetails', 'Expand details')}
    >
      {imageUrl ? (
        <img
          src={imageUrl}
          alt={entityDetails.name}
          className="w-14 h-14 object-cover rounded-md flex-shrink-0"
          onError={handleImageError}
        />
      ) : IconComponent ? (
        <div className={`w-14 h-14 ${bgColor} rounded-md flex items-center justify-center flex-shrink-0`}>
          <IconComponent className={`w-7 h-7 ${iconColor}`} />
        </div>
      ) : null}

      <div className="flex-1 min-w-0">
        <h3 className="font-semibold text-gray-900 truncate text-base">{entityDetails.name}</h3>
        <p className="text-xs text-gray-500 truncate mt-0.5">{entityDetails.currentAddress || entityDetails.current_address || ''}</p>
        <LiveStatusChip isLive={isLive} liveUntil={localLiveUntil} />
      </div>

      <button
        onClick={(e) => { e.stopPropagation(); onExpand('expanded') }}
        className="flex-shrink-0 p-1 hover:bg-gray-100 rounded-full transition-colors"
        aria-label={t('common.expandDetails', 'Expand details')}
      >
        <ChevronUpIcon className="w-5 h-5 text-gray-500" />
      </button>
    </div>
  )
})

export default EntitySemiMode
